/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, April 3rd 2022, 8:56:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useAPIFetchItem, useAPIMutation, useAPIFetchList, APISERVICEPATHS, useAPIForm, UseAPIFormSpec } from "lib/api";
import { BillingSchedule, BillingScheduleValidationSchema } from "lib/schemas";

/** BillingSchedules API */

const billingScheduleAPIServicePath = APISERVICEPATHS.billingSchedules;

export const useAPIFetchBillingSchedule = () =>
  useAPIFetchItem<BillingSchedule>({
    apiServicePath: billingScheduleAPIServicePath,
    makeRequestOnInitialMount: false,
  });

export const useAPIListBillingSchedules = () =>
  useAPIFetchList<BillingSchedule>({
    apiServicePath: billingScheduleAPIServicePath,
    makeRequestOnInitialMount: false,
  });

export const useAPIMutateBillingSchedule = () =>
  useAPIMutation<BillingSchedule>({
    apiServicePath: billingScheduleAPIServicePath,
  });

export interface UseBillingScheduleAPIFormSpec {
  billingScheduleFetchId: UseAPIFormSpec<BillingSchedule>["apiInitialFetchId"];
  billingScheduleDefaultValues: BillingSchedule;
  updateBillingScheduleFromAPICallback: UseAPIFormSpec<BillingSchedule>["setAPIFormResponse"];
}

export const useBillingScheduleAPIForm = ({
  billingScheduleFetchId,
  billingScheduleDefaultValues,
  updateBillingScheduleFromAPICallback,
}: UseBillingScheduleAPIFormSpec) => {
  return useAPIForm({
    apiServicePath: billingScheduleAPIServicePath,
    apiFormDataValidationSchema: BillingScheduleValidationSchema,
    apiFormDefaultValues: billingScheduleDefaultValues,
    apiInitialFetchId: billingScheduleFetchId,
    primaryKey: "id",
    setAPIFormResponse: updateBillingScheduleFromAPICallback,
  });
};
